import React from 'react';
import { Box } from '@material-ui/core';

import { PassUploadTab } from './PassUploadTab';

export const BulkUpload = () => {
  return (
    <Box>
      <PassUploadTab />
    </Box>
  );
};